import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { isDanishPrivate, isDanishPrivateWebshop } from '../../constants/siteIds';

type EmailDescriptionProps = {
  iimclient: ConfigClientType;
};

// These were the only places where texts['email-description'] was used
const PageExceptions = {
  dkpriv: 'Skriv til os sikkert via Mine Sider.',
  dkprivwebshop: 'Skriv til os sikkert via Mine Sider.',
};

// This was only visible in DK Priv and DK Priv Webshop and so translations are inline
const EmailDescription = ({ iimclient }: EmailDescriptionProps) => {
    const isRendered = isDanishPrivate(iimclient.myfullpath) && isDanishPrivateWebshop(iimclient.myfullpath);
    
    return isRendered && (
      <p id="email-description">{PageExceptions.dkpriv}</p>
    );
};

export default EmailDescription;
